// extracted by mini-css-extract-plugin
module.exports = {"header":"AttributeDetailModal_header__2XeEr","content":"AttributeDetailModal_content__2RW_z","row":"AttributeDetailModal_row__1cgKm"};